import React from 'react';
import './Contact.css';

// Clean SVG icons that match the warm brown theme
const EmailIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3 8L10.89 13.26C11.2187 13.4793 11.6049 13.5963 12 13.5963C12.3951 13.5963 12.7813 13.4793 13.11 13.26L21 8M5 19H19C19.5304 19 20.0391 18.7893 20.4142 18.4142C20.7893 18.0391 21 17.5304 21 17V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H5C4.46957 5 3.96086 5.21071 3.58579 5.58579C3.21071 5.96086 3 6.46957 3 7V17C3 17.5304 3.21071 18.0391 3.58579 18.4142C3.96086 18.7893 4.46957 19 5 19Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const LinkedInIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
  </svg>
);

const Contact = () => {
  return (
    <section id="contact" className="section contact">
      <div className="contact-container">
        <h2 className="section-title">Get In Touch</h2>
        <div className="contact-content">
          <div className="contact-info">
            <h3>Let's Connect</h3>
            <p>
              I'm always interested in discussing opportunities in law,
              legal advocacy, and making a positive impact in the community.
              Feel free to reach out!
            </p>

            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon">
                  <EmailIcon />
                </div>
                <div className="contact-text">
                  <h4>Email</h4>
                  <a href="mailto:20gmartinez@gmail.com">20gmartinez@gmail.com</a>
                </div>
              </div>

              <div className="contact-item">
                <div className="contact-icon">
                  <LinkedInIcon />
                </div>
                <div className="contact-text">
                  <h4>LinkedIn</h4>
                  <a
                    href="https://www.linkedin.com/in/gabrielle-g-martinez/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Connect with me on LinkedIn
                  </a>
                </div>
              </div>
            </div>
          </div>
          
          <div className="contact-cta">
            <h3>Ready to Make a Difference</h3>
            <p>
              Passionate about using legal expertise to advocate for immigrant rights, 
              community justice, and positive social change. Let's work together to 
              create a more just and equitable society.
            </p>
            <div className="cta-buttons">
              <a href="mailto:20gmartinez@gmail.com" className="cta-button primary">
                Send Email
              </a>
              <a 
                href="https://www.linkedin.com/in/gabrielle-g-martinez/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="cta-button secondary"
              >
                View LinkedIn
              </a>
            </div>
          </div>
        </div>
        
        <div className="footer">
          <p>&copy; 2025 Gabrielle Grace Martinez. All rights reserved.</p>
        </div>
      </div>
    </section>
  );
};

export default Contact;
